<template>
  <div :class="b('', { active })">
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  // type Setup = {};
  // type Data = {};

  /**
   * Reusable style wrapper for the mobile menu.
   */
  export default defineComponent({
    name: 'c-main-navigation-mobile-wrapper',

    // components: {},

    props: {
      /**
       * Define if the menu is active.
       */
      active: {
        type: Boolean,
        default: false,
      },
    },
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    // data(): Data {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .c-main-navigation-mobile-wrapper {
    display: none;
    position: absolute;
    top: var(--theme-header-height);
    left: 0;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100% - var(--theme-header-height));
    background-color: var(--theme-color-primary--1);
    box-shadow: 0 0 10px var(--theme-color-grayscale--0);

    @include mixins.media(sm) {
      width: 20rem;
    }

    @include mixins.media($down: md) {
      &--active {
        display: flex;
      }
    }
  }
</style>
